<script>
import { DatePicker } from 'v-calendar';

export default {
  name: 'RobFormModal',
  components: { DatePicker },
  props: {
    visible: Boolean,
    isEditMode: Boolean,
    isSubmitting: Boolean,
    initialData: Object,
  },
  data() {
    return {
      form: {
        mrobId: null,
        startTime: new Date(),
        endTime: new Date(),
        initialValue: null,
      },
    };
  },
  computed: {
    title() {
      return this.isEditMode ? 'Edit ROB Profile' : 'Create New ROB Profile';
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.isEditMode && this.initialData) {
          this.form = { ...this.initialData };
        } else {
          this.resetForm();
        }
      }
    },
  },
  methods: {
    resetForm() {
      this.form = {
        mrobId: null,
        startTime: new Date(),
        endTime: new Date(),
        initialValue: null,
      };
    },
    handleSubmit() {
      if (!this.form.startTime || !this.form.endTime || !this.form.initialValue) {
        this.$toast.error('All fields are required.');
        return;
      }
      this.$emit('submit', this.form);
    },
    closeModal() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<template>
  <b-modal :visible="visible" :title="title" @hidden="closeModal" hide-footer>
    <b-form @submit.prevent="handleSubmit">
      <b-form-group label="Start Date & Time">
        <date-picker v-model="form.startTime" mode="dateTime" is24hr>
          <template v-slot="{ inputValue, inputEvents }">
            <b-form-input :value="inputValue" v-on="inputEvents" required readonly />
          </template>
        </date-picker>
      </b-form-group>
      <b-form-group label="End Date & Time">
        <date-picker v-model="form.endTime" mode="dateTime" is24hr>
          <template v-slot="{ inputValue, inputEvents }">
            <b-form-input :value="inputValue" v-on="inputEvents" required readonly />
          </template>
        </date-picker>
      </b-form-group>
      <b-form-group label="Initial Supply in Liters">
        <b-form-input v-model="form.initialValue" type="number" required step="any"/>
      </b-form-group>
      <div class="d-flex justify-content-end">
        <b-button variant="secondary" @click="closeModal" class="mr-2">Cancel</b-button>
        <b-button type="submit" variant="primary" :disabled="isSubmitting">
          {{ isSubmitting ? 'Saving...' : 'Save' }}
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>
